/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateIncidentRuleDto,
  IncidentRulesControllerCreateV1201,
  IncidentRulesControllerCreateV1PathParameters,
  IncidentRulesControllerDeleteV1PathParameters,
  IncidentRulesControllerFindAllV1200,
  IncidentRulesControllerFindAllV1Params,
  IncidentRulesControllerFindAllV1PathParameters,
  IncidentRulesControllerPopulateSimilarV1200,
  IncidentRulesControllerPopulateSimilarV1PathParameters,
  IncidentRulesControllerUpdateV1200,
  IncidentRulesControllerUpdateV1PathParameters,
  PopulateSimilarIncidentRulesDto,
  UpdateIncidentRuleDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class IncidentRulesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Create a new incident rule for a device
   */

  create<TData = IncidentRulesControllerCreateV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: IncidentRulesControllerCreateV1PathParameters,
    createIncidentRuleDto: CreateIncidentRuleDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/incident-rules`, createIncidentRuleDto);
  }
  /**
   * @summary Retrieve all incident rules for a device
   */

  findAll<TData = IncidentRulesControllerFindAllV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: IncidentRulesControllerFindAllV1PathParameters,
    params?: IncidentRulesControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/incident-rules`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Copies the incident rule to the given target devices. Validates datapoints, reports devices that already have a rule for the same code, and optionally replaces existing non-system rules.
   * @summary Populate an incident rule from the source device to selected devices
   */

  populateSimilar<TData = IncidentRulesControllerPopulateSimilarV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, ruleId }: IncidentRulesControllerPopulateSimilarV1PathParameters,
    populateSimilarIncidentRulesDto: PopulateSimilarIncidentRulesDto,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/devices/v1/clients/${clientId}/devices/${deviceId}/incident-rules/${ruleId}/populate-similar`,
      populateSimilarIncidentRulesDto,
    );
  }
  /**
   * @summary Update an incident rule
   */

  update<TData = IncidentRulesControllerUpdateV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, id }: IncidentRulesControllerUpdateV1PathParameters,
    updateIncidentRuleDto: UpdateIncidentRuleDto,
  ): Observable<TData> {
    return this.http.put<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/incident-rules/${id}`, updateIncidentRuleDto);
  }
  /**
   * @summary Delete an incident rule
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
    id,
  }: IncidentRulesControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/incident-rules/${id}`);
  }
}
